import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useStores } from '../store/useStores';

function LoginRoute() {
  const { authStore } = useStores();

  if (!authStore.isLoggedIn) return <Outlet />;
  return <Navigate to="/" replace />;
}

export default observer(LoginRoute);
